export const authStates = {
    UNKNOWN: 'UNKNOWN',
    LOGGED_OUT: 'LOGGED-OUT',
    NOT_VERIFIED: 'NOT-VERIFIED',
    NOT_CONFIGURED: 'NOT-CONFIGURED',
    // @TODO We can remove NOT_IN_COMPANY and all references
    NOT_IN_COMPANY: 'NOT-IN-COMPANY',
    FULLY_CONFIGURED: 'FULLY-CONFIGURED',
    CHOOSE_ORGANIZATION: 'CHOOSE-ORGANIZATION',
    ACCOUNT_SELECTED: 'ACCOUNT-SELECTED',
    CREATE_ORGANIZATION: 'CREATE-ORGANIZATION',
};
